import { fadeInScaleUpTransition as e } from "../../../_styles/transitions/fade-in-scale-up.cssr.js";
import { cB as o, c as n, cNotM as t, cM as r, cE as i } from "../../../_utils/cssr/index.js";
const l = o("dropdown-menu", `
 transform-origin: var(--v-transform-origin);
 background-color: var(--n-color);
 border-radius: var(--n-border-radius);
 box-shadow: var(--n-box-shadow);
 position: relative;
 transition:
 background-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
`, [e(), o("dropdown-option", `
 position: relative;
 `, [n("a", `
 text-decoration: none;
 color: inherit;
 outline: none;
 `, [n("&::before", `
 content: "";
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `)]), o("dropdown-option-body", `
 display: flex;
 cursor: pointer;
 position: relative;
 height: var(--n-option-height);
 line-height: var(--n-option-height);
 font-size: var(--n-font-size);
 color: var(--n-option-text-color);
 transition: color .3s var(--n-bezier);
 `, [n("&::before", `
 content: "";
 position: absolute;
 top: 0;
 bottom: 0;
 left: 4px;
 right: 4px;
 transition: background-color .3s var(--n-bezier);
 border-radius: var(--n-border-radius);
 `), t("disabled", [r("pending", `
 color: var(--n-option-text-color-hover);
 `, [i("prefix, suffix", `
 color: var(--n-option-text-color-hover);
 `), n("&::before", "background-color: var(--n-option-color-hover);")]), r("active", `
 color: var(--n-option-text-color-active);
 `, [i("prefix, suffix", `
 color: var(--n-option-text-color-active);
 `), n("&::before", "background-color: var(--n-option-color-active);")]), r("child-active", `
 color: var(--n-option-text-color-child-active);
 `, [i("prefix, suffix", `
 color: var(--n-option-text-color-child-active);
 `)])]), r("disabled", `
 cursor: not-allowed;
 opacity: var(--n-option-opacity-disabled);
 `), r("group", `
 font-size: calc(var(--n-font-size) - 1px);
 color: var(--n-group-header-text-color);
 `, [i("prefix", `
 width: calc(var(--n-option-prefix-width) / 2);
 `, [r("show-icon", `
 width: calc(var(--n-option-icon-prefix-width) / 2);
 `)])]), i("prefix", `
 width: var(--n-option-prefix-width);
 display: flex;
 justify-content: center;
 align-items: center;
 color: var(--n-prefix-color);
 transition: color .3s var(--n-bezier);
 z-index: 1;
 `, [r("show-icon", `
 width: var(--n-option-icon-prefix-width);
 `), o("icon", `
 font-size: var(--n-option-icon-size);
 `)]), i("label", `
 white-space: nowrap;
 flex: 1;
 z-index: 1;
 `), i("suffix", `
 box-sizing: border-box;
 flex-grow: 0;
 flex-shrink: 0;
 display: flex;
 justify-content: flex-end;
 align-items: center;
 min-width: var(--n-option-suffix-width);
 padding: 0 8px;
 transition: color .3s var(--n-bezier);
 color: var(--n-suffix-color);
 z-index: 1;
 `, [r("has-submenu", `
 width: var(--n-option-icon-suffix-width);
 `), o("icon", `
 font-size: var(--n-option-icon-size);
 `)]), o("dropdown-menu", "pointer-events: all;")]), o("dropdown-offset-container", `
 pointer-events: none;
 position: absolute;
 left: 0;
 right: 0;
 top: -4px;
 bottom: -4px;
 `)]), o("dropdown-divider", `
 transition: background-color .3s var(--n-bezier);
 background-color: var(--n-divider-color);
 height: 1px;
 margin: 4px 0;
 `), o("dropdown-menu-wrapper", `
 transform-origin: var(--v-transform-origin);
 width: fit-content;
 `), n(">", [o("scrollbar", `
 height: inherit;
 max-height: inherit;
 `)]), t("scrollable", `
 padding: var(--n-padding);
 `), r("scrollable", [i("content", `
 padding: var(--n-padding);
 `)])]);
export {
  l as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/dropdown/src/styles/index.cssr.js
// module id = 1685
// module chunks = 67